import React from 'react';
import Image from '@react/shared/Image';
const WebinarCard = ({ title, image, url, content, day, time, month, dates, year, pinText, }) => (React.createElement("div", { className: "grid-column" },
    React.createElement("a", { href: url, className: "card card--webinar", "data-aos": "animated" },
        React.createElement("div", { className: "card__inner" },
            React.createElement("div", { className: "card__media" },
                React.createElement("div", { className: "card__media-holder" },
                    React.createElement(Image, { image: image, alt: title, ratio: 1, width: 460, className: "card__media-element", cdn: true })),
                React.createElement("div", { className: "card__date-block" },
                    React.createElement("span", { className: "card__date-block-month" }, month),
                    React.createElement("span", { className: "card__date-block-day" }, dates),
                    React.createElement("span", { className: "card__date-block-year" }, year))),
            React.createElement("div", { className: "card__content-external" },
                React.createElement("div", { className: "tag tag--purple" }, pinText),
                React.createElement("div", { className: "card__content-internal" },
                    React.createElement("h4", { className: "card__title" }, title),
                    React.createElement("div", { className: "card__intro" }, content),
                    React.createElement("p", { className: "card__blog-detail" },
                        React.createElement("span", { className: "card__webinar-date" }, day),
                        time)))))));
export default WebinarCard;
